<template>
  <div class="color-sample n1-west">
    <section>
      <p class="small-text">
        享年 八十八歳
      </p>
    </section>
    <section>
      <p class="default-text">
        俗名 源頼朝
      </p>
    </section>
    <section>
      <p class="small-text">
        平成三年 十二月三十 一日 没
      </p>
    </section>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-back.scss";
</style>
